export class TaskAction {
  static readonly type = '[Task] Add item';
  constructor(public payload: string) { }
}

export class LoadTasks {
  static readonly type = '[Task] Load tasks';
  constructor(public userId: string, public groups: string) { }
}
